import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-team-member',
  templateUrl: './modern-team-member.component.html',
  styleUrls: ['./modern-team-member.component.scss']
})
export class ModernTeamMemberComponent implements OnInit {

  constructor() { }
  users = [
    {
      img: 'assets/images/traces/nimia125.jpg',
      name: ' נמיה',
      designation: 'פלמחים',
    },
    {
      img: 'assets/images/traces/camel125.jpg',
      name: ' גמל',
      designation: 'מדבר יהודה',
    },
    {
      img: 'assets/images/traces/dorban125.jpg',
      name: ' דורבן',
      designation: 'ערבה',
    },
    {
      img: 'assets/images/traces/cat125.jpg',
      name: ' חתול',
      designation: 'תל אביב',
    },
  ];

  ngOnInit() {
  }
}
